import { useQuery } from "@tanstack/react-query";

import { getReferralValues } from "services";

import { DEFAULT_CACHE_TIME } from "consts";

import { Referrals } from "models";

export const useGetReferralValues = () => {
  const defaultData = {
    firstMethodReferralValue: 0,
    firstYearlyDataReferralValue: 0,
    referralValue: 0,
  };

  const { data, isLoading } = useQuery<Referrals>({
    queryKey: ["getReferralValues"],
    queryFn: ({ signal }) => getReferralValues({ signal }),
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });

  return { referralValues: data || defaultData, referralValuesLoading: isLoading };
};
